import styles from "../../../styles/component-styles/admin/modals.module.scss";
export function Overlay({ children }) {
  return (
    <div className={styles.overlay}>
      {children}
    </div>
  );
}